import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/inherits.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { PanSession } from './PanSession.mjs';
import { addPointerEvent } from '../../events/add-pointer-event.mjs';
import { Feature } from '../../motion/features/Feature.mjs';
import { noop } from '../../utils/noop.mjs';
import { getContextWindow } from '../../utils/get-context-window.mjs';
import { frame } from '../../frameloop/frame.mjs';
var asyncHandler = function asyncHandler(handler) {
  return function (event, info) {
    if (handler) {
      frame.postRender(function () {
        return handler(event, info);
      });
    }
  };
};
var PanGesture = /*#__PURE__*/function (_Feature) {
  function PanGesture() {
    var _this;
    _classCallCheck(this, PanGesture);
    _this = _callSuper(this, PanGesture, arguments);
    _this.removePointerDownListener = noop;
    return _this;
  }
  _inherits(PanGesture, _Feature);
  return _createClass(PanGesture, [{
    key: "onPointerDown",
    value: function onPointerDown(pointerDownEvent) {
      this.session = new PanSession(pointerDownEvent, this.createPanHandlers(), {
        transformPagePoint: this.node.getTransformPagePoint(),
        contextWindow: getContextWindow(this.node)
      });
    }
  }, {
    key: "createPanHandlers",
    value: function createPanHandlers() {
      var _this2 = this;
      var _this$node$getProps = this.node.getProps(),
        onPanSessionStart = _this$node$getProps.onPanSessionStart,
        onPanStart = _this$node$getProps.onPanStart,
        onPan = _this$node$getProps.onPan,
        onPanEnd = _this$node$getProps.onPanEnd;
      return {
        onSessionStart: asyncHandler(onPanSessionStart),
        onStart: asyncHandler(onPanStart),
        onMove: onPan,
        onEnd: function onEnd(event, info) {
          delete _this2.session;
          if (onPanEnd) {
            frame.postRender(function () {
              return onPanEnd(event, info);
            });
          }
        }
      };
    }
  }, {
    key: "mount",
    value: function mount() {
      var _this3 = this;
      this.removePointerDownListener = addPointerEvent(this.node.current, "pointerdown", function (event) {
        return _this3.onPointerDown(event);
      });
    }
  }, {
    key: "update",
    value: function update() {
      this.session && this.session.updateHandlers(this.createPanHandlers());
    }
  }, {
    key: "unmount",
    value: function unmount() {
      this.removePointerDownListener();
      this.session && this.session.end();
    }
  }]);
}(Feature);
export { PanGesture };